import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";
import Swal from "sweetalert2";

export const razorpaySpotGoldOrderApi = createAsyncThunk(
  "razorpayPostOrder",
  async (payload) => {
    try {
      const response = await axiosInstance.post(
        "/merchant/order/create2",
        payload
      );

      if (!response.data.error) {
        return response.data;
      } else {
        Swal.fire({
          title: response.data.message,
          icon: "error",
        });
      }
    } catch (error) {
        console.log("error in create2 api=======",error)
      Swal.fire({
        title: error?.response?.data?.message || "something went wrong!!!",
        icon: "error",
      });
    }
  }
);

const razorpaySpotGoldOrderSlice = createSlice({
  name: "razorpayPostOrder",
  initialState: {
    data: [],
    errors: [],
    status: "idle",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(razorpaySpotGoldOrderApi.pending, (state) => {
        state.status = "loading";
      })
      .addCase(razorpaySpotGoldOrderApi.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = "idle";
      })
      .addCase(razorpaySpotGoldOrderApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.status = "idle";
      });
  },
});

export default razorpaySpotGoldOrderSlice.reducer;
